module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Norm-Center",
    attrs: {
      "id": "auto_bookmark_toc_3"
    }
  }, [_c('span', [_vm._v("To Mate, of course, and Mary, who saw this one first. To Jason, who gets random manuscripts and is like, “Hunh—what car was he driving?” and to Steve, Nebula, Dewey, and Jelly, who every night turn my kitchen into "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("West Side Story")]), _vm._v(", the Sharks vs. the Jets, stalking each other to music in their own minds.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bd1666","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0003.vue
// module id = 63
// module chunks = 0